import { useMutation } from '@apollo/client';
import { NEW_MONRI_PAYMENT, NEW_MONRI_DIGEST } from '../queries/cart';

export const useNewMonriPayment = () => {
  const [getPaymentInfo, paymentResponse] = useMutation(NEW_MONRI_PAYMENT);
  const [getDigestInfo, digestResponse] = useMutation(NEW_MONRI_DIGEST);

  const generatePaymentData = (amount, orderNumber, reservedOrderNumber) => {
    return getPaymentInfo({
      variables: {
        amount,
        orderNumber,
        reservedOrderNumber,
      },
    });
  };

  const generatePaymentDigestData = async (amount, orderNumber) => {
    const digestInfoResponse = await getDigestInfo({
      variables: {
        amount,
        orderNumber,
      },
    });
    return digestInfoResponse.data.newMonriDigest.digest;
  };

  return [generatePaymentData, generatePaymentDigestData, paymentResponse, digestResponse];
};
